import { clampHeadingLevel, renderContentHtml } from './contentHtml';
import type { TextUnitData } from './useComponent';
import styles from './TextUnit.module.css';

// The sanitize-and-render pipeline lives in contentHtml so the PDF export shares
// it verbatim. Re-exported here because many modules already import the type
// from this file.
export type { HeadingLevel } from './contentHtml';

interface TextUnitProps {
  headingLevel?: import('./contentHtml').HeadingLevel;
  hideHeading?: boolean;
  unit: TextUnitData;
}

export function TextUnit({
  headingLevel,
  hideHeading = false,
  unit,
}: TextUnitProps) {
  const HeadingTag = `h${clampHeadingLevel(headingLevel)}` as const;
  const visibleHeading = hideHeading
    ? null
    : unit.numberedHeading ?? unit.heading ?? null;

  return (
    <article className={styles.unit}>
      {visibleHeading ? (
        <HeadingTag className={styles.heading} id={unit.anchorId}>
          {visibleHeading}
        </HeadingTag>
      ) : null}
      <div className={`${styles.content} lesson-content`}>
        {renderContentHtml(unit.html)}
      </div>
      {unit.caption ? <p className={styles.caption}>{unit.caption}</p> : null}
    </article>
  );
}
